export default () => ({
  input: {
    width: '100%',
  },
});
